<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trails="trails"></crumbs>
    <div class="media-checking">
      <!-- 媒体商信息查询条件区域 -->
      <div class="filter-search">
        <el-form :inline="true" :rules="rules" :model="searchData" ref="searchForm">
          <el-form-item label="媒体商ID：" prop="userId">
            <el-input onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" maxlength="9" type="text" size="small" v-model="searchData.userId" clearable placeholder="请输入媒体商ID"></el-input>
          </el-form-item>
          <el-form-item label="审核状态：" prop="status">
            <el-select size="small" v-model="searchData.status" placeholder="审核状态">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="审核中" value="1"></el-option>
              <el-option label="已驳回" value="2"></el-option>
              <el-option label="已通过" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请日期：" prop="applyTime">
            <el-date-picker size="small" v-model="searchData.applyTime" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="操作日期：" prop="operateTime">
            <el-date-picker size="small" v-model="searchData.operateTime" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getMediaInfo(1)">查询</el-button>
            <a class="export-button" :disabled="!ExportData" :href="exportUrl" target="_blank">导出数据</a>
          </el-form-item>
        </el-form>
      </div>
      <!-- 审核数据类型选择区域 -->
      <div class="data-type">
        <span class="el-icon-menu data-size">审核数据（{{dataSize}}）</span>
        <el-button :type="nature === 1? 'primary':'default'" size="small" @click="changeType(1)">公司信息</el-button>
        <el-button :type="nature === 0? 'primary':'default'" size="small" @click="changeType(0)">个人信息</el-button>
      </div>
      <!-- 数据列表 -->
      <div class="data-list">
        <!-- 公司媒体商审核信息列表 -->
        <template v-if="nature">
          <el-table :data="tableData" stripe header-row-class-name="table-header-style" style="width: 100%">
            <el-table-column align="center" fixed="left" label="操作" width="80">
              <template slot-scope="scope">
                <el-button @click="resolveCheck(scope.row)" type="text" size="small" :disabled="scope.row.Status != 1 || !Review">通过
                </el-button>
                <el-button @click="rejectCheck(scope.row)" type="text" size="small" :disabled="scope.row.Status != 1 || !Review">驳回
                </el-button>
              </template>
            </el-table-column>
            <el-table-column align="center" :formatter="formatDater" prop="AddDate" label="申请日期" min-width="110">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="UserId" label="媒体商ID" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="CompanyName" label="公司名称" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="CompanyAddress" label="公司地址" min-width="130">
            </el-table-column>
            <el-table-column align="center" prop="BusiLicenseNum" label="营业执照号" min-width="250">
            </el-table-column>
            <el-table-column align="center" prop="BusinessLicenseImg" label="营业执照" min-width="130">
              <template slot-scope="scope">
                <img :src="scope.row.BusinessLicenseImg" alt="" width="100" @click="showImage(scope.row.BusinessLicenseImg)">
              </template>
            </el-table-column>
            <el-table-column align="center" prop="OpeningPermissionImg" label="开户许可证" min-width="130">
              <template slot-scope="scope">
                <img :src="scope.row.OpeningPermissionImg" alt="" width="100" @click="showImage(scope.row.OpeningPermissionImg)">
              </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="AccountOpenCompany" label="开户公司" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="AccountBranch" label="开户银行支行" min-width="130">
            </el-table-column>
            <el-table-column align="center" prop="BankAccount" label="银行账号" min-width="250">
            </el-table-column>
            <el-table-column :formatter="formatDater" align="center" prop="UpdateDate" label="操作时间" min-width="110">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="StatusName" label="状态" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="AuditNote" label="备注" width="180">
            </el-table-column>
          </el-table>
        </template>
        <!-- 个人媒体商审核信息列表 -->
        <template v-else>
          <el-table :data="tableData" stripe header-row-class-name="table-header-style" style="width: 100%">
            <el-table-column align="center" fixed="left" label="操作" width="80">
              <template slot-scope="scope">
                <el-button @click="resolveCheck(scope.row)" type="text" size="small" :disabled="scope.row.Status != 1 || !Review">通过
                </el-button>
                <el-button @click="rejectCheck(scope.row)" type="text" size="small" :disabled="scope.row.Status != 1 || !Review">驳回
                </el-button>
              </template>
            </el-table-column>
            <el-table-column align="center" :formatter="formatDater" prop="AddDate" label="申请日期" min-width="110">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="UserId" label="媒体商ID" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="Name" label="姓名" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="CompanyAddress" label="地址" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="IdCardNumber" label="身份证号" min-width="130">
            </el-table-column>
            <el-table-column align="center" prop="IdCardFrontImg" label="身份证正面" min-width="130">
              <template slot-scope="scope">
                <img :src="scope.row.IdCardFrontImg" alt="" width="100" @click="showImage(scope.row.IdCardFrontImg)">
              </template>
            </el-table-column>
            <el-table-column align="center" prop="IdCardRearImg" label="身份证反面" min-width="130">
              <template slot-scope="scope">
                <img :src="scope.row.IdCardRearImg" alt="" width="100" @click="showImage(scope.row.IdCardRearImg)">
              </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="BankUserName" label="开户名称" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="AccountBranch" label="开户银行支行" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="BankAccount" label="银行账号" min-width="130">
            </el-table-column>
            <el-table-column :formatter="formatDater" align="center" prop="UpdateDate" label="操作时间" min-width="110">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="StatusName" label="状态" min-width="130">
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="AuditNote" label="备注" width="180">
            </el-table-column>
          </el-table>
        </template>
        <!-- 分页设置 -->
        <el-pagination background layout="prev, pager, next" :total="dataSize" :page-size="pageSize" :current-page="currentPage" @current-change="pageChange">
        </el-pagination>

      </div>
      <!-- 图片放大弹层 -->
      <el-dialog :visible.sync="IsShowImage" width="50%">
        <div class="image-content">
          <span class="close-image-modal" @click="IsShowImage = false">×</span>
          <img :src="imageUrl" alt="" @error="imgError">
        </div>
      </el-dialog>
    </div>
    <!-- 审核弹层设置 -->
    <confirmDialog :isShowdialog="isShowDiaLog" @close='closeDialog' :dialogPragram="dialogPragram"></confirmDialog>

  </div>
</template>

<script type="text/ecmascript-6">
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
// 审核弹层
import confirmDialog from "../public/confirm-dialog";
// 格式化时间
import { formatDateAll } from "common/js/common";
// api
import {
  // 媒体商审核信息接口
  getmediaInfo,
  // 媒体商审核接口
  reviewMediaInfo,
  // 导出数据接口
  outPutMediaInfo
} from "api/mediaChecking";

export default {
  data() {
    var validateUserId = (rule, value, callback) => {
      if (value != "") {
        if (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false) {
          callback(new Error("请填写数字！"));
        } else if (value > 999999999) {
          callback(new Error("输入不能超过9个字符"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      // 搜索条件
      searchData: {
        userId: "",
        status: "-1",
        applyTime: "",
        operateTime: ""
      },
      rules: {
        userId: [{ validator: validateUserId, trigger: "change" }]
      },
      // 面包屑
      trails: [
        {
          trail: "客户管理",
          href: ""
        },
        {
          trail: "媒体信息审核",
          href: ""
        }
      ],
      // 媒体商类型
      nature: 1,
      // 列表长度
      dataSize: 0,
      // 是否显示驳回和通过弹框
      isShowDiaLog: false,
      // 放大图片路径
      imageUrl: "",
      // 是否显示放大图片弹框
      IsShowImage: false,
      // 驳回和通过弹框参数
      dialogPragram: {
        title: "提示",
        id: "",
        name: "",
        remark: false,
        type: "",
        content: "",
        nature: 1,
        callback: null
      },
      // 表格数据
      tableData: [],
      // 分页当前页
      currentPage: 1,
      // 分页每页条数
      pageSize: 20
    };
  },
  computed: {
    // 导出数据路径和参数
    exportUrl() {
      var filterData = {
        nature: this.nature,
        UserId: this.searchData.userId,
        status: this.searchData.status - 0,
        reqBeginDate: this.searchData.applyTime
          ? this.searchData.applyTime[0]
          : "",
        reqEndDate: this.searchData.applyTime
          ? this.searchData.applyTime[1]
          : "",
        operatingBeginDate: this.searchData.operateTime
          ? this.searchData.operateTime[0]
          : "",
        operatingEndDate: this.searchData.operateTime
          ? this.searchData.operateTime[1]
          : ""
      };
      var url = `/IAD_MediaCertificationReq/ExportData?_t=${new Date().getTime()}`;
      for (var key in filterData) {
        url += `&${key}=${
          filterData[key] || filterData[key] === 0 ? filterData[key] : ""
        }`;
      }
      return url;
    },
    // 审核权限
    Review() {
      if (this.$store.state.authorization.IAD_MediaCertificationReq) {
        if (
          this.$store.state.authorization.IAD_MediaCertificationReq.PageFuncs
        ) {
          return this.$store.state.authorization.IAD_MediaCertificationReq
            .PageFuncs.Review;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // 浏览权限
    List() {
      if (this.$store.state.authorization.IAD_MediaCertificationReq) {
        if (
          this.$store.state.authorization.IAD_MediaCertificationReq.PageFuncs
        ) {
          return this.$store.state.authorization.IAD_MediaCertificationReq
            .PageFuncs.List;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    // 导出权限
    ExportData() {
      if (this.$store.state.authorization.IAD_MediaCertificationReq) {
        if (
          this.$store.state.authorization.IAD_MediaCertificationReq.PageFuncs
        ) {
          return this.$store.state.authorization.IAD_MediaCertificationReq
            .PageFuncs.ExportData;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  components: {
    // 面包屑
    crumbs,
    // 审核弹框
    confirmDialog
  },
  methods: {
    inputNum(evt) {
      //火狐使用evt.which获取键盘按键值，IE使用window.event.keyCode获取键盘按键值
      var ev = evt.which ? evt.which : window.event.keyCode;
      console.log(ev);
      if (ev >= 48 && ev <= 57) {
        return true;
      } else {
        return false;
      }
    },
    // 初始化搜索条件和分页当前页
    initSearchData() {
      this.searchData = {
        userId: "",
        status: "-1",
        applyTime: "",
        operateTime: ""
      };
      this.currentPage = 1;
    },
    getMediaInfo(type) {
      if (type) {
        this.currentPage = 1;
      }

      var filterData = {
        pageIndex: this.currentPage,
        pageSize: 20,
        nature: this.nature,
        UserId: this.searchData.userId,
        status: this.searchData.status - 0,
        reqBeginDate: this.searchData.applyTime
          ? this.searchData.applyTime[0]
          : "",
        reqEndDate: this.searchData.applyTime
          ? this.searchData.applyTime[1]
          : "",
        operatingBeginDate: this.searchData.operateTime
          ? this.searchData.operateTime[0]
          : "",
        operatingEndDate: this.searchData.operateTime
          ? this.searchData.operateTime[1]
          : ""
      };
      this.$nextTick(() => {
        this.$refs["searchForm"].validate(valid => {
          if (valid) {
            getmediaInfo(filterData)
              .then(res => {
                if (res.list) {
                  this.tableData = res.list;
                  this.dataSize = res.count;
                } else {
                  this.tableData = res.list;
                  this.dataSize = res.count;
                }
              })
              .catch(err => {
                this.tableData = res.list;
                this.dataSize = res.count;
              });
          } else {
            return false;
          }
        });
      });
    },
    // 切换媒体商类型
    changeType(type) {
      this.nature = type;
      this.initSearchData();
      this.getMediaInfo();
    },
    // 关闭审核弹框
    closeDialog(retData) {
      this.isShowDiaLog = false;
      var toast = "";
      if (retData) {
        switch (retData.status) {
          case -1:
            toast = "操作失败";
            break;
          case 0:
            this.getMediaInfo();
            break;
          case -2:
            toast = "媒体商名称不一致";
            break;
          case -3:
            toast = "审核失败";
            break;
          case -4:
            toast = "信息已经审核过";
            break;
        }
        this.$nextTick(function() {
          if (retData.status !== 0) {
            var that = this;
            setTimeout(function() {
              that.isShowDiaLog = true;
              that.dialogPragram.title = "提示";
              that.dialogPragram.toast = toast;
            }, 500);
          }
        });
      }
    },
    // 通过审核操作
    resolveCheck(row) {
      if (this.nature) {
        this.dialogPragram.title = "通过公司信息";
      } else {
        this.dialogPragram.title = "通过个人信息";
      }

      this.dialogPragram.id = row.UserId;
      this.dialogPragram.nature = this.nature;
      this.dialogPragram.name = row.CompanyName || row.Name;
      this.dialogPragram.remark = false;
      this.dialogPragram.type = "通过";
      this.dialogPragram.BusinessId = row.BusinessId;
      this.isShowDiaLog = true;
      this.dialogPragram.callback = reviewMediaInfo;
    },
    // 驳回审核操作
    rejectCheck(row) {
      if (this.nature) {
        this.dialogPragram.title = "驳回公司信息";
      } else {
        this.dialogPragram.title = "驳回个人信息";
      }
      this.dialogPragram.id = row.UserId;
      this.dialogPragram.nature = this.nature;
      this.dialogPragram.name = row.CompanyName || row.Name;
      this.dialogPragram.remark = true;
      this.dialogPragram.type = "驳回";
      this.dialogPragram.BusinessId = row.BusinessId;
      this.isShowDiaLog = true;
      this.dialogPragram.callback = reviewMediaInfo;
    },
    // 显示图片放大弹框
    showImage(url) {
      this.imageUrl = url;
      this.IsShowImage = true;
    },
    // 图片显示出错操作
    imgError() {
      this.imageUrl = require("../../common/img/b_img.png");
    },
    // 格式化日期
    formatDater(row, column, cellValue, index) {
      return formatDateAll(cellValue);
    },
    // 分页切换页码
    pageChange(currentPage) {
      this.currentPage = currentPage;
      this.getMediaInfo();
    }
  },
  created() {
    document.title = "媒体商审核";
    this.getMediaInfo();
  },
  mounted() {}
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}

ul.nav {
  padding: 0 !important;
}

#navbar .sign-in-wrap {
  padding-right: 50px !important;
}

.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}

#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}

.money-icon {
  margin-right: 5px !important;
}

.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}

.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}

.putonArea .region {
  margin-top: 4px !important;
}

.putonArea .region .provinces-group {
  width: 650px !important;
}

.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}

.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}

.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}

.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss">
@import "../../common/scss/color.scss";

.media-checking {
  .filter-search {
    border: 1px solid #f2f2f2;
    padding: 20px 15px;
    .el-input {
      width: 150px;
    }
    .el-select {
      .el-input {
        width: 120px;
      }
    }
    .el-date-editor {
      width: 240px;
    }
    .el-button {
      min-width: 94px;
    }
    .export-button {
      width: 94px;
      display: inline-block;
      color: #fff;
      background-color: #5798d7;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      border: 1px solid #5798d7;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin-left: 10px;
      padding: 9px 15px;
      font-size: 12px;
      border-radius: 4px;
      &:hover {
        background: #66b1ff;
        border-color: #66b1ff;
        color: #fff;
      }
    }
  }
  .data-type {
    padding: 15px;
    .data-size {
      color: #bbbbbb;
      font-size: 14px;
    }
    .el-icon-menu:before {
      font-size: 18px;
      vertical-align: middle;
    }
  }
  .data-list {
    .el-table {
      .el-button {
        margin: 0;
        width: 100%;
        font-size: 14px;
      }
      thead {
        tr {
          background-color: #f5f5f5 !important;
          border-bottom: 2px solid #bbb;
          text-align: center;
        }
      }
    }

    .el-pagination {
      text-align: center;
      margin: 30px 0;
    }
  }
  .image-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #000;
    .close-image-modal {
      display: inline-block;
      width: 20px;
      height: 20px;
      position: absolute;
      top: -5px;
      right: -5px;
      font-size: 28px;
      color: #e5e5e5;
      background-color: #fff;
      line-height: 15px;
      border-radius: 10px;
      cursor: pointer;
    }
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer-management/media-checking.vue